import A11yModalButton from './modules/a11y-modal-button'
import A11yPopupButton from './modules/a11y-popup-button'
import A11yBlockLink from './modules/a11y-block-link'
import A11yAutofocus from './modules/a11y-autofocus'
import A11yDrawer from './modules/a11y-drawer'
import A11ySkipContent from './modules/a11y-skip-content'
import A11yAppendContentToLink from './modules/a11y-append-content-to-link'
import './modules/a11y-input-enter-click'

export default function () {
  A11yAppendContentToLink()

  new A11ySkipContent(document.querySelector('.js-a11y-skip-content'))

  document.querySelectorAll('.js-a11y-modal-button').forEach((element) => {
    let button = new A11yModalButton(element)
    button.init()
  })

  document.querySelectorAll('.js-a11y-popup-button').forEach((element) => {
    let button = new A11yPopupButton(element)
    button.init()
  })
  document.querySelectorAll('.js-a11y-block-link').forEach((element) => {
    let blocklink = new A11yBlockLink(element)
    blocklink.init()
  })
  document.querySelectorAll('.js-a11y-autofocus').forEach((element) => {
    let autofocus = new A11yAutofocus(element)
    autofocus.init()
  })
  document.querySelectorAll('.js-a11y-drawer').forEach((element) => {
    new A11yDrawer(element)
  })
}
